import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader } from '@cloudflare/kumo/components/loader';
import { maskEmail } from '@nt-tokyo/shared';
import { useSession, authClient } from '@/lib/authClient';

interface Props {
  children: ReactNode;
}

// 受付端末 (/kiosk) の保護。受付専用アカウント (role = 'kiosk') と admin が使える。
// 未ログイン → /sign-in。それ以外の役割は、受付端末の画面に合わせた大きな文字で拒否する。
export default function RequireKiosk({ children }: Props) {
  const { data, isPending } = useSession();
  const location = useLocation();

  if (isPending) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader />
      </div>
    );
  }

  if (!data?.user) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/sign-in?redirect=${redirect}`} replace />;
  }

  const role = data.user.role;
  // API (kioskMiddleware) と同じく、古い super-admin も admin と同じ扱いで許可する
  if (role !== 'kiosk' && role !== 'admin' && role !== 'super-admin') {
    return (
      <div className="mx-auto flex max-w-2xl flex-col gap-6 px-6 py-16 text-center">
        <h1 className="text-3xl font-extrabold">この画面は受付端末専用です</h1>
        <p className="text-lg text-kumo-muted">
          {/* 受付端末の画面は後ろに並ぶ人にも見えるので、メールアドレスは伏せる */}
          ログイン中のメールアドレス: <strong>{maskEmail(data.user.email)}</strong>
        </p>
        <button
          type="button"
          className="mx-auto rounded-xl border-2 px-8 py-4 text-xl font-bold"
          onClick={async () => {
            await authClient.signOut();
            window.location.href = '/sign-in?redirect=%2Fkiosk';
          }}
        >
          ログアウトして別アカウントで入り直す
        </button>
      </div>
    );
  }

  return <>{children}</>;
}
